import React, { createContext, useContext, useState, useEffect, useRef } from "react";
import socket from "../Utils/socketClient";

const LivePriceContext = createContext();

export const useLivePrices = () => {
  return useContext(LivePriceContext);
};

export const LivePriceProvider = ({ children }) => {
  const [livePrices, setLivePrices] = useState({});
  const pricesRef = useRef({});

  useEffect(() => {
    const handleForexData = (data) => {
      const rawTicker = data?.data?.ticker;
      const symbol = rawTicker?.toLowerCase();
      const price = Number(data?.data?.Mid_Price);
      
      if (symbol && !isNaN(price)) {
        const newPrice = price.toFixed(4);
        if (pricesRef.current[symbol] !== newPrice) {
          pricesRef.current[symbol] = newPrice;
        }
      }
    };

    const handleAliceTicks = (data) => {
      const token = data?.tk;
      const price = Number(data?.lp);
      if (token && !isNaN(price)) {
        const newPrice = price.toFixed(2);
        if (pricesRef.current[token] !== newPrice) {
          pricesRef.current[token] = newPrice;
        }
      }
    };

    socket.on("receive_data_forex", handleForexData);
    socket.on("alice_ticks", handleAliceTicks);

    const intervalId = setInterval(() => {
      setLivePrices((prev) => {
        let hasChanges = false;
        for (const key in pricesRef.current) {
          if (prev[key] !== pricesRef.current[key]) {
            hasChanges = true;
            break;
          }
        }
        if (hasChanges) {
          return { ...prev, ...pricesRef.current };
        }
        return prev;
      });
    }, 1000); // Update frontend state every 1 second to optimize renders

    return () => {
      socket.off("receive_data_forex", handleForexData);
      socket.off("alice_ticks", handleAliceTicks);
      clearInterval(intervalId);
    };
  }, []);

  return (
    <LivePriceContext.Provider value={{ livePrices }}>
      {children}
    </LivePriceContext.Provider>
  );
};
